module.exports = __webpack_public_path__ + "img/industry_icon.9e4d58ef.svg";